import { LogikFormItem } from '../../../shared/logik/components/LogikFormItem';
import { LogikFieldsEnum } from '../../../shared/logik/constants/fields.constant';
import { LogikSwitch } from '../../../shared/logik/components/LogikSwitch';
import { Section } from '../../../shared/components/layout/Section';
import { LogikFormList } from '../../../shared/logik/components/LogikFormList';
import { AddCustomRequestButton } from './AddCustomRequestButton';
import { SkeletonRow } from './SkeletonRow';
import { CustomRequestRow } from './CustomRequestRow';
import { useFieldValue } from '../../../shared/logik/hooks/field.hooks';
import { useCallback } from 'react';
import { updateConfiguration } from '../../widget/thunks/basic/updateConfiguration';
import { useAppDispatch } from '../../../app/hooks';

export function SummaryCustomRequests(): JSX.Element {
    const dispatch = useAppDispatch();

    const handWrittenOption = useFieldValue<boolean>(LogikFieldsEnum.handWrittenOption);

    const handleToggleChange = useCallback(
        async (checked: boolean) => {
            if (!checked) {
                await dispatch(
                    updateConfiguration({
                        updates: [
                            {
                                set: LogikFieldsEnum.set_of_custom_requests,
                                variableName: `set.${LogikFieldsEnum.set_of_custom_requests}.size`,
                                value: [],
                            },
                        ],
                    }),
                );
            }
        },
        [dispatch],
    );

    return (
        <>
            <LogikFormItem
                label={<span style={{ whiteSpace: 'normal' }}>Order Contains Custom Requests</span>}
                labelCol={{ span: 18 }}
                wrapperCol={{ span: 6 }}
                direction='horizontal'
                logikName={LogikFieldsEnum.handWrittenOption}
                valuePropName='checked'
                hasFeedback={false}>
                <LogikSwitch onChange={handleToggleChange} />
            </LogikFormItem>

            {handWrittenOption && (
                <>
                    <Section titleElement='Custom Requests'>
                        <LogikFormList
                            name={LogikFieldsEnum.set_of_custom_requests}
                            setName={LogikFieldsEnum.set_of_custom_requests}
                            ignoreInited={true}>
                            {(fields, { add, remove }, meta, isAddingRow, isRemovingRow) => {
                                return (
                                    <>
                                        <AddCustomRequestButton add={add} />

                                        {fields.map(({ key, name, ...rest }) => {
                                            if (!isRemovingRow) {
                                                return <CustomRequestRow index={name} remove={remove} key={name} />;
                                            } else {
                                                return <SkeletonRow key={name} />;
                                            }
                                        })}
                                        {isAddingRow && <SkeletonRow />}
                                    </>
                                );
                            }}
                        </LogikFormList>
                    </Section>
                </>
            )}
        </>
    );
}
